var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / Linear"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.00002 17.75C8.90002 17.75 8.81002 17.73 8.71002 17.69C8.5732 17.6341 8.45627 17.5385 8.37428 17.4155C8.2923 17.2925 8.24902 17.1478 8.25002 17V11C8.25002 10.59 8.59002 10.25 9.00002 10.25C9.41002 10.25 9.75002 10.59 9.75002 11V15.19L10.47 14.47C10.76 14.18 11.24 14.18 11.53 14.47C11.82 14.76 11.82 15.24 11.53 15.53L9.53002 17.53C9.39002 17.67 9.19002 17.75 9.00002 17.75Z",
    fill: "#0061AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.99965 17.7514C8.80965 17.7514 8.61966 17.6814 8.46966 17.5314L6.46965 15.5314C6.33017 15.3903 6.25195 15.1998 6.25195 15.0014C6.25195 14.803 6.33017 14.6125 6.46965 14.4714C6.75965 14.1814 7.23966 14.1814 7.52965 14.4714L9.52965 16.4714C9.81965 16.7614 9.81965 17.2414 9.52965 17.5314C9.37965 17.6814 9.18965 17.7514 8.99965 17.7514Z",
    fill: "#0061AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H14C14.41 1.25 14.75 1.59 14.75 2C14.75 2.41 14.41 2.75 14 2.75H9C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V10C21.25 9.59 21.59 9.25 22 9.25C22.41 9.25 22.75 9.59 22.75 10V15C22.75 20.43 20.43 22.75 15 22.75Z",
    fill: "#0061AF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22 10.7475H18C14.58 10.7475 13.25 9.41755 13.25 5.99755V1.99755C13.25 1.69755 13.43 1.41755 13.71 1.30755C13.99 1.18755 14.31 1.25755 14.53 1.46755L22.53 9.46755C22.6343 9.57262 22.7052 9.70616 22.7338 9.8514C22.7624 9.99664 22.7474 10.1471 22.6908 10.2839C22.6342 10.4206 22.5384 10.5376 22.4155 10.6201C22.2926 10.7026 22.148 10.7469 22 10.7475ZM14.75 3.80755V5.99755C14.75 8.57755 15.42 9.24755 18 9.24755H20.19L14.75 3.80755Z",
    fill: "#0061AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.1a144368b45805373a9b84278cc9f3e0.svg";
export { ForwardRef as ReactComponent };